import store from '../../../../global-state/redux';

export const isActive = () => store.getState().appState.settings?.loggedInOnly?.isActive;
export const modalName = () => store.getState().appState.settings?.loggedInOnly?.modalName;
